'use client'

import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import {
   Navigation,
   Pagination,
   Autoplay,
   EffectCoverflow,
   Keyboard,
} from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-coverflow'

export default function AiMlAutomation({
   amtitle,
   amsubtitle,
   amdesc,
   slides,
}) {
   return (
      <>
         <section className="page_top_section custom-slider-1-section section_theme_2_bg">
            <div className="container text-center  innovation_comman">
               <h2
                  className="tech_title section_heading_title mb-2"
                  //   style="max-width: 1100px"
                  style={{ maxWidth: '1200px' }}
               >
                  {amtitle}
               </h2>

               <p className="tech_body tech_title mb-3">{amsubtitle}</p>
               <p className="sub_body">{amdesc}</p>
            </div>
            <div className="slider-section">
               <div className="slider-column">
                  <div className="automation-sm-slider">
                     <Swiper
                        className={'custom-slider-1'}
                        modules={[
                           Navigation,
                           Pagination,
                           Autoplay,
                           EffectCoverflow,
                           Keyboard,
                        ]}
                        autoplay={{
                           delay: 3000,
                           disableOnInteraction: false,
                        }}
                        centeredSlides={true}
                        grabCursor={true}
                        loop={true}
                        keyboard={{ enabled: true }}
                        speed={1000}
                        pagination={{
                           el: '.swiper-pagination-slider-1',
                           clickable: true,
                           renderBullet: (index, className) =>
                              `<span class="${className} custom-bullet"></span>`,
                        }}
                        navigation={{
                           nextEl: '.custom-next-btn',
                           prevEl: '.custom-prev-btn',
                        }}
                        effect="coverflow"
                        coverflowEffect={{
                           rotate: 0,
                           stretch: -10,
                           depth: 100,
                           modifier: 2,
                           slideShadows: false,
                        }}
                        breakpoints={{
                           320: {
                              slidesPerView: 1,
                              spaceBetween: 100,
                              centeredSlides: true,
                           },
                           640: {
                              slidesPerView: 1.25,
                              spaceBetween: 200,
                              centeredSlides: true,
                           },
                           768: {
                              slidesPerView: 1.25,
                              spaceBetween: 200,
                              centeredSlides: true,
                           },
                           1100: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                           },
                        }}
                     >
                        <div className="automation-sm-slider">
                           {slides.map((slide, index) => (
                              <SwiperSlide key={index}>
                                 <div className="row slider_card flex-column justify-content-between">
                                    <div className="d-flex gap-3 flex-column flex-sm-row">
                                       <div className="col-12 col-sm-3 d-flex justify-content-center align-items-center">
                                          <div className="ai-chip">
                                             <img
                                                src={slide.icon}
                                                height="70"
                                                width="70"
                                                alt="icon"
                                             />
                                          </div>
                                       </div>
                                       <div className="col-12 col-sm-9 card_content text-center text-sm-start">
                                          <div className="card_top_text text-uppercase">
                                             {slide.topText}
                                          </div>
                                          <div className="card_header mb-2 mt-2">
                                             {slide.header}
                                          </div>
                                          <div className="card_details">
                                             {slide.details}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </SwiperSlide>
                           ))}
                        </div>

                        {/* Custom pagination and nav outside slide loop */}
                        <div className="d-flex justify-content-center slider-1-navigation-parent">
                           <button className="custom-prev-btn me-3">
                              <div>
                                 <img
                                    src="/assets/svg/technologies/previous_icon.svg"
                                    alt="prev"
                                 />
                              </div>
                           </button>
                           <div className="d-flex align-items-center justify-content-center">
                              <span className="d-flex align-items-center justify-content-center swiper-pagination-slider-1"></span>
                           </div>
                           <button className="custom-next-btn ms-3 ">
                              <div>
                                 <img
                                    src="/assets/svg/technologies/next_icon.svg"
                                    alt="next"
                                 />
                              </div>
                           </button>
                        </div>
                     </Swiper>
                  </div>
                  <div className="automation-lg-slider">
                     <Swiper
                        className={'custom-slider-1'}
                        modules={[
                           Navigation,
                           Pagination,
                           Autoplay,
                           EffectCoverflow,
                           Keyboard,
                        ]}
                        autoplay={{
                           delay: 3000,
                           disableOnInteraction: false,
                        }}
                        centeredSlides={false}
                        grabCursor={true}
                        loop={true}
                        keyboard={{ enabled: true }}
                        speed={1000}
                        pagination={{
                           el: '.swiper-pagination-slider-1',
                           clickable: true,
                           renderBullet: (index, className) =>
                              `<span class="${className} custom-bullet"></span>`,
                        }}
                        navigation={{
                           nextEl: '.custom-next-btn',
                           prevEl: '.custom-prev-btn',
                        }}
                        effect="coverflow"
                        coverflowEffect={{
                           rotate: 0,
                           stretch: -10,
                           depth: 100,
                           modifier: 2,
                           slideShadows: false,
                        }}
                        breakpoints={{
                           320: {
                              slidesPerView: 1,
                              spaceBetween: 100,
                              centeredSlides: true,
                           },
                           640: {
                              slidesPerView: 1.25,
                              spaceBetween: 200,
                              centeredSlides: true,
                           },
                           768: {
                              slidesPerView: 1.25,
                              spaceBetween: 200,
                              centeredSlides: true,
                           },
                           1100: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                           },
                           1600: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -250,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           1650: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -245,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           1700: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -240,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           1750: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -235,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           1800: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -230,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           1850: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -225,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           1900: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -220,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           1950: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -210,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2000: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -200,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2050: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -185,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2100: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -170,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2150: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -157,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2200: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -145,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2250: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -133,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2300: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -120,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2350: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -110,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2400: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -100,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2450: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -85,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                           2500: {
                              slidesPerView: 2,
                              spaceBetween: 85,
                              centeredSlides: true,
                              coverflowEffect: {
                                 rotate: 0,
                                 stretch: -70,
                                 depth: 10,
                                 modifier: 2,
                                 slideShadows: false,
                              },
                           },
                        }}
                     >
                        <div className="automation-lg-slider">
                           {Array.from(
                              { length: Math.ceil(slides.length / 2) },
                              (_, i) => (
                                 <SwiperSlide key={i}>
                                    <div className="d-flex gap-2">
                                       {[slides[i * 2], slides[i * 2 + 1]]
                                          .filter(Boolean)
                                          .map((slide, idx) => (
                                             <div
                                                key={idx}
                                                className="row slider_card flex-column justify-content-between"
                                             >
                                                <div className="d-flex gap-3 flex-column flex-sm-row">
                                                   <div className="col-12 col-sm-3 d-flex justify-content-center align-items-center">
                                                      <div className="ai-chip">
                                                         <img
                                                            src={slide.icon}
                                                            height="70"
                                                            width="70"
                                                            alt="icon"
                                                         />
                                                      </div>
                                                   </div>
                                                   <div className="col-12 col-sm-9 card_content text-center text-sm-start">
                                                      <div className="card_top_text text-uppercase">
                                                         {slide.topText}
                                                      </div>
                                                      <div className="card_header mb-2 mt-2">
                                                         {slide.header}
                                                      </div>
                                                      <div className="card_details">
                                                         {slide.details}
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          ))}
                                    </div>
                                 </SwiperSlide>
                              )
                           )}
                        </div>

                        {/* Custom pagination and nav outside slide loop */}
                        <div className="d-flex justify-content-center slider-1-navigation-parent">
                           <button className="custom-prev-btn me-3">
                              <div>
                                 <img
                                    src="/assets/svg/technologies/previous_icon.svg"
                                    alt="prev"
                                 />
                              </div>
                           </button>
                           <div className="d-flex align-items-center justify-content-center">
                              <span className="d-flex align-items-center justify-content-center swiper-pagination-slider-1"></span>
                           </div>
                           <button className="custom-next-btn ms-3 ">
                              <div>
                                 <img
                                    src="/assets/svg/technologies/next_icon.svg"
                                    alt="next"
                                 />
                              </div>
                           </button>
                        </div>
                     </Swiper>
                  </div>
               </div>
            </div>
         </section>
      </>
   )
}
